import { environment } from '../../../environments/environment';

const BASE_URL = environment.apiUrl;

async function request<T>(path: string, options?: RequestInit): Promise<T> {
  const res = await fetch(`${BASE_URL}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error(body.message || `Request failed (${res.status})`);
  }
  const text = await res.text();
  return text ? JSON.parse(text) : (null as T);
}

export const authClient = {
  getSession() {
    return request<{ session: any; user: any }>('/api/auth/get-session');
  },
  signIn(email: string, password: string) {
    return request<{ session: any; user: any }>('/api/auth/sign-in/email', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    });
  },
  signOut() {
    return request<void>('/api/auth/sign-out', { method: 'POST', body: "{}"});
  },
  /** Update the current user's own profile (name, optional avatar image). */
  updateUser(values: { name?: string; image?: string | null }) {
    return request<{ status: boolean }>('/api/auth/update-user', {
      method: 'POST',
      body: JSON.stringify(values),
    });
  },
  /** Change the current user's own password (requires the current one). */
  changePassword(currentPassword: string, newPassword: string) {
    return request<{ status?: boolean }>('/api/auth/change-password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword, revokeOtherSessions: false }),
    });
  },
};
